export const AUDIT_SUBSYSTEMS = {
  KB_AUDIT : "kb-audit",
  ASSISTANT_SETTINGS_AUDIT: "assistant-settings-audit",
};

